export interface IPriceAdjustment {
  appliedDiscount: { amount: number; percentage?: number; type: string }
  couponCode: string
  itemText?: string
  priceAdjustmentId: string
  promotionId: string
}

export const getCustomerCreditUsed = (priceAdjustments: IPriceAdjustment[]) => {
  const customerCreditUsed = priceAdjustments?.reduce(
    (acc: number, adjustment: any) => {
      if (adjustment?.promotionId?.startsWith('CustomerCredit-')) {
        return acc + adjustment?.price
      }
      return acc
    },
    0
  )

  return Math.abs(customerCreditUsed)
}

export const getDiscountsWithoutCustomerCredit = (
  priceAdjustments: IPriceAdjustment[]
) => {
  const discountsUsed = priceAdjustments?.reduce(
    (acc: number, adjustment: any) => {
      if (!adjustment?.promotionId?.startsWith('CustomerCredit-')) {
        return acc + adjustment?.price
      }
      return acc
    },
    0
  )

  return Math.abs(discountsUsed)
}

export const getTotalCustomerCreditUsedInItems = (basket: any) => {
  let customerCreditUsed = 0
  basket?.productItems?.map((productItem: any) => {
    if (productItem?.priceAdjustments?.length) {
      customerCreditUsed += getCustomerCreditUsed(productItem.priceAdjustments)
    }
  })
  return Math.abs(customerCreditUsed)
}
